import { Navigate, Outlet } from 'react-router-dom'

import { paths } from '@/app/router/paths'
import { useCanViewWebsiteForm } from '@/features/settings/hooks/useCanViewWebsiteForm'

/** Without `LEAD_CREATE` the server refuses `GET /api/website-intake`, so the page would be empty. */
export function WebsiteFormRoute() {
  const canView = useCanViewWebsiteForm()

  if (!canView) return <Navigate to={paths.settings} replace />

  return <Outlet />
}
